// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".a1FeBaCc1kb4nU {\n  position: absolute;\n  top: 0;\n  bottom: 10px;\n  right: 10px;\n  left: 10px;\n  border-radius: 3px;\n}\n.a1FeBaCc1kb4nU.ppOKG1RncXt4PA {\n  left: calc(16px + 10px);\n}\n.a1FeBaCc1kb4nU > div {\n  border-radius: 3px;\n}\nbody.ff-modernization-update .a1FeBaCc1kb4nU {\n  margin: 12px 2px 2px 2px;\n  border-radius: 8px;\n}\nbody.ff-modernization-update .a1FeBaCc1kb4nU > div {\n  border-radius: 8px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "a1FeBaCc1kb4nU",
	"collapsedWorkspaceNavigation": "ppOKG1RncXt4PA"
};
export default ___CSS_LOADER_EXPORT___;
